module.exports = __webpack_public_path__ + "media/images/pc/shop/step-02-990c6e38fe45d5c4fd150edf6d5c5f22.png";